import React from 'react'
import { Helmet } from 'react-helmet'
import favicon from './assets/images/favicon.ico'
import './assets/css/_font.css'
import './assets/css/_material-icons.css'

const Head = () => {
    return (
        <>
            <Helmet>
                <meta charset="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, shrink-to-fit=no" />
                <meta http-equiv="X-UA-Compatible" content="ie=edge" />
                <meta name="keywords" content="Nextap : Guest Experience" />
                <meta name="author" content="Nextap : Guest Experience" />
                <meta name="robots" content="Nextap : Guest Experience" />
                <meta name="description" content="Nextap : Guest Experience" />
                <meta property="og:title" content="" />
                <meta property="og:description" content="Nextap : Guest Experience" />
                <meta property="og:image" content="assets/images/favicon.png" />
                <link rel="icon" type="image/x-icon" href={favicon} />
                <title>NexTap : Guest Experience</title>
            </Helmet>
        </>
    )
}

export default Head;